<p class="snack t-flex colgap-8" *ngIf="this.data?.message">
    <mat-icon *ngIf="data.icon">{{data.icon}}</mat-icon> 
    <mat-icon *ngIf="!data.icon"  class="checkmark_skyblue" svgIcon="checkmark_skyblue"
aria-hidden="false" aria-label="checkmark_skyblue"></mat-icon>
     {{data.message}} </p>
<ng-container *ngTemplateOutlet="this.data.snackBarContent"></ng-container>
